import { rankName } from '@vmt/shared';
import clsx from 'clsx';
import { useRankTiers } from '../hooks/data';

export function RankIcon({
  tier,
  className,
}: {
  tier: number | null | undefined;
  className?: string;
}) {
  const { lookup } = useRankTiers();
  const icon = tier ? lookup.get(tier)?.iconUrl : null;
  if (!icon) {
    return (
      <span
        className={clsx('inline-block rounded-full bg-ink-700', className ?? 'size-6')}
        aria-hidden
      />
    );
  }
  return (
    <img
      src={icon}
      alt=""
      loading="lazy"
      className={clsx('object-contain', className ?? 'size-6')}
    />
  );
}

export function RankBadge({
  tier,
  label,
  compact,
  rr,
}: {
  tier: number | null | undefined;
  label?: string;
  compact?: boolean;
  /** RR within the tier (shown if known). */
  rr?: number | null;
}) {
  const rrText = tier != null && rr != null ? ` · ${rr} RR` : '';
  return (
    <span
      className="inline-flex items-center gap-1.5"
      title={`${label ? `${label}: ` : ''}${rankName(tier)}${rrText}`}
    >
      <RankIcon tier={tier} className={compact ? 'size-5' : 'size-7'} />
      {!compact && (
        <span className="leading-tight">
          {label && (
            <span className="block text-[10px] tracking-wider text-ink-400 uppercase">{label}</span>
          )}
          <span className="text-sm font-medium">
            {rankName(tier)}
            {rrText && <span className="font-normal text-ink-400">{rrText}</span>}
          </span>
        </span>
      )}
    </span>
  );
}
